import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { fetchAccountProfile, updateAccountProfile, changePassword } from '@/services/account';
import type { UpdateProfileInput, ChangePasswordInput } from '@/types/account';

const ACCOUNT_PROFILE_KEY = ['admin', 'account', 'profile'];

export function useAccountProfile() {
  return useQuery({
    queryKey: ACCOUNT_PROFILE_KEY,
    queryFn: fetchAccountProfile,
  });
}

export function useUpdateAccountProfile() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (input: UpdateProfileInput) => updateAccountProfile(input),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ACCOUNT_PROFILE_KEY });
    },
  });
}

export function useChangePassword() {
  return useMutation({
    mutationFn: (input: ChangePasswordInput) => changePassword(input),
  });
}
